import { takeLatest, put, call } from "redux-saga/effects";
import {
  FETCH_RM_BUDDIES_WAREHOUSE_LIST,
  setRmBuddiesWarehouseList
} from "../actions";

import {
  setLoaderModal,
  setReplayOnAuthentication,
  setUserAuthenticated,
  setErrorToastMessage
} from "../../geofence/actions";

import { getWarehouses } from "../../../api/common/warehouse";

export function* fetchWarehousesTask(action) {
  try {
    yield put(setLoaderModal(true));
    // TODO: Add proper pagination or server side search when warehouse list increases.
    const result = yield call(getWarehouses, 100, 1);
    const list = result.data.warehouseList;
    yield put(setRmBuddiesWarehouseList(list));
    yield put(setLoaderModal(false));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setLoaderModal(false));
    yield put(setErrorToastMessage(e.response.data.message));
  }
}

export function* watchFetchWarehouse() {
  yield takeLatest(FETCH_RM_BUDDIES_WAREHOUSE_LIST, fetchWarehousesTask);
}
